import { setAuthToken } from "@crema/services/ApiConfig";
import React, { useEffect } from "react";


const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];


const AppLogOut = ({ children }) => {
let timer;
useEffect(() => {
  Object.values(events).forEach((item) => {
    window.addEventListener(item, () => {
      // console.log('trigereeddd')
      resetTimer();
      handleTimer();
    });
  });

  setInterval(()=> {
    let flag = localStorage.getItem('isLogOut') || 'false';
    if(JSON.parse(flag)){
      resetTimer();
    }
  },1000 )
}, []);

const resetTimer = () => {
  if (timer) clearTimeout(timer);
};

const handleTimer = () => {
  timer = setTimeout(() => {
    resetTimer();
    Object.values(events).forEach((item) => {
      window.removeEventListener(item, resetTimer);
    });
    logoutAction();
  }, 3600000);
};

const logoutAction = () => {
    setAuthToken(null);
  localStorage.clear();
  window.location.pathname = "/";
};

  return children;
};

export default AppLogOut;